import React, { useState, useEffect } from "react";
//import {Form, Alert } from "react-bootstrap";
import {connect, useSelector} from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';
//import moment from 'moment';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Card from '@material-ui/core/Card';
//import CardActionArea from '@material-ui/core/CardActionArea';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Paper from '@material-ui/core/Paper';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Chip from '@mui/material/Chip';
import {styled} from '@mui/material/styles';
//import Row from 'react-bootstrap/Row';
//import Col from 'react-bootstrap/Col';
//import Card from 'react-bootstrap/Card';
import { Divider, makeStyles } from '@material-ui/core';
//import ArrowDownward from '@material-ui/icons/ArrowDownward';
//import DataTable from 'react-data-table-component';
import FormGroup from '@material-ui/core/FormGroup';
import FormControl from '@material-ui/core/FormControl';
//import TextField from '@material-ui/core/TextField';
import MaskedInput from 'react-text-mask';
import Button from '@material-ui/core/Button';

import * as actions from '../store/actions/index';
import * as actionTypes from '../store/actions/actionTypes';

const StyledChip = styled(Chip)(({theme}) => ({
    fontSize: 12,
    "& .MuiChip-label":{
      padding: '2px 5px 1px'
    },
    margin: '0px',
    borderRadius: '1px',
    color: '#fff'
}));

const useStyles = makeStyles(theme => ({
    root: {
        borderRadius: 12,
        minWidth: 256,
        textAlign: 'center',
    },
    header: {
        textAlign: 'left',
        spacing: 10,
    },
    list: {
        padding: '20px',
    },
    button: {
        margin: theme.spacing(1),
    },
    action: {
        display: 'flex',
        justifyContent: 'space-around',
    },
    input: {
        borderRadius: 4,
        position: 'relative',
        color: theme.palette.text.primary,
        backgroundColor: theme.palette.background.paper,
        border: '1px solid #ced4da',
        fontSize: 16,
        padding: '10px 5px 10px 5px',
        margin: theme.spacing(1),
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        // Use the system font instead of the default Roboto font.
        fontFamily: [
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif',
            '"Apple Color Emoji"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
        ].join(','),
        '&:focus': {
            borderRadius: 4,
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
        },
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    }
}));

function ResellerMacCheck(props) {
    const classes = useStyles();
    const [macAddress, setMacAddress] = useState("00:1A:79:");
    const [customAlert, setCustomAlert] = useState("");

    useEffect(()=>{
        props.onSearchMacInitialize();
    },[]);

    const spinner = (
        <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
        />
    );

    useEffect(() => {
        if (props.searchMac !== null){
            let message = 'Mac address is available';
            let title = "Success";
            let type = actionTypes.SNACKBAR_TYPE_SUCCESS;
            let severity = "success";
            setCustomAlert(
                <Alert severity={severity} fullWidth>
                    {message}
                </Alert>
            );
            if(props.searchMac.found){
                //console.log('loggiing searchMac', props.searchMac);
                message = 'Mac address is in use';
                type = actionTypes.SNACKBAR_TYPE_ERROR;
                severity = "error";
                title = "Error";
                setCustomAlert(
                    <Alert severity={severity} fullWidth>
                        {message} {(props.searchMac.subMessage==="ACTIVE")? <StyledChip label={props.searchMac.subMessage} sx={{backgroundColor: '#4caf50'}} size="small"/> : <StyledChip label={props.searchMac.subMessage} sx={{backgroundColor: '#f44336'}} size="small"/>}
                    </Alert>
                    );
            }
            props.onSearchMacInitialize();
            //props.onDisplaySnackbar({type: type, message: message});
        }
    },[props.searchMac]);

    function handleSubmit(event) {
        event.preventDefault();
        //console.log("login", client.name);
        //console.log("password", client.password);
        //console.log("macaddress", client.mac);
        //console.log("months", months);
        //console.log("description", client.description);
        //console.log("phone", client.phone);
        const data = {
            //name: props.currentDealerName,
            mac: macAddress

        };
        console.log('logging data', data);
        //props.onRetrieveCredits(props.token, data);
        props.onSearchMac(props.token, macAddress);

    }

    function validateForm() {
        return macAddress.length === 17;
    }

    return (
        <Container>
            <Grid container spacing={2}>
                <Grid item md={12}></Grid>
                <Grid item md={12} sm={12} xs={12}>
                    <Paper elevation={5}>
                        <Card>
                            <CardHeader
                                title="Check MAC Address"
                                titleTypographyProps={{
                                    fontSize: 17,
                                    fontWeight: 'bold'
                                }} 
                            />
                            <Divider variant="middle" />
                            <CardContent>
                                <form>
                                    <FormGroup row>
                                        <FormControl className={classes.formControl}>
                                            <MaskedInput
                                                mask={[/[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':' , /[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':' , /[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':', /[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':' , /[A-Fa-f0-9]/, /[A-Fa-f0-9]/, ':' , /[A-Fa-f0-9]/, /[A-Fa-f0-9]/]}
                                                className={classes.input}
                                                placeholder="Mac Address"
                                                value={macAddress}
                                                guide={false}
                                                id="macAddress"
                                                onChange={e => setMacAddress(e.target.value)}
                                            />
                                        </FormControl>
                                    </FormGroup>
                                    <Grid item md={12} sm={12} xs={12}>
                                    {customAlert}
                                    </Grid>
                                </form>
                            </CardContent>
                            <CardActions>
                            <Button
                                        block
                                        disabled={!validateForm() || props.isLoadingSearchMac}
                                        type="submit"
                                        onClick={handleSubmit}
                                        variant="contained"
                                        color="primary"
                                        size="small"
                                        fullWidth
                                    >
                                        {props.isLoadingSearchMac
                                            ? spinner
                                            : 'Search'}
                                    </Button>            
                            </CardActions>
                        </Card>
                    </Paper>
                </Grid>
            </Grid>
        </Container>

    );
}

const mapDispatchToProps = dispatch => {
    return {
        onSearchMac: (token, mac) => dispatch(actions.searchMacReseller(token, mac)),
        onSearchMacInitialize: () => dispatch(actions.initializeSearchMac()),
        onDisplaySnackbar: (message) => dispatch(actions.showSuccessSnackbar(message))
    }
};

const mapStateToProps = state => {
    return {
        token: state.auth.token,
        searchMac: state.searchMac.data,
        isLoadingSearchMac: state.searchMac.loading,
        isFailSearchMac: state.searchMac.error
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(ResellerMacCheck);